module.exports = __webpack_public_path__ + "media/images/top-9-c32ec8102c0fdab9628f13c40e8d665a.png";